const textFieldModalEquipServQuest = {
  name: 'Pergunta',
  description: 'Detalhamento da Pergunta *',
  helperText: '* objetivo deste campo é ajudar o executor à responder esta pergunta da maneira correta'
};

export default textFieldModalEquipServQuest;
